import React from 'react';

/**
 * iOS 风格的应用图标组件
 * @param {Object} props
 * @param {string} props.href - 跳转链接
 * @param {string} props.title - 图标下方文字
 * @param {ReactNode} props.icon - 图标元素
 * @param {string} props.color - 渐变色类名，如 'from-blue-500 to-blue-600'
 * @param {string} props.className - 额外类名
 * @param {Function} props.onClick - 点击事件
 */
const AppIcon = ({ href, title, icon, color, className = '', onClick }) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  const Component = href ? 'a' : 'div';
  const props = href ? { href } : {};

  return (
    <Component
      {...props}
      onClick={handleClick}
      className={`flex flex-col items-center gap-1.5 active:scale-90 transition-transform ${className}`}
    >
      {/* 图标容器 - iOS 风格的圆角方形 */}
      <div className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-gradient-to-br ${color} 
        flex items-center justify-center shadow-md text-white text-3xl md:text-4xl`}>
        {icon}
      </div>
      {/* 应用名称 */}
      <span className="text-xs md:text-sm text-gray-700 font-medium text-center leading-tight">
        {title}
      </span>
    </Component>
  );
};

export default AppIcon;
